<app-application-container>
  <div class="pt-3 pr-3 d-flex flex-column flex-grow-1 h-100">
    <router-outlet></router-outlet>
  </div>
</app-application-container>


// WEBPACK FOOTER //
// ./src/app/developer/developer.component.html